import { inject, Injectable } from '@angular/core';
import { Email, EmailTemplatePreviewFieldConfig } from '../../../shared/models/generated/ziroModels';
import { Nvp } from '../../../shared/models/nvp';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AuditHeaderService } from '../../../shared/services/audit-header.service';
import { ZiroModalService } from '../../../shared/services/ziro-modal.service';
import { EmailPreviewDetailedModalComponent } from '../../cisco/send-email/email-preview-detailed-modal/email-preview-detailed-modal.component';
import { ZiroIcons } from '../../../shared/models/ziro-icons.enum';
import { ToastService } from '../../../shared/services/toast.service';
import { ToastTypes } from '../../../shared/services/abstract/toast.service.abstract';

@Injectable()
export class EmailService {
  private http = inject(HttpClient);
  private auditHeaderService = inject(AuditHeaderService);
  private ziroModalService = inject(ZiroModalService);
  private toastService = inject(ToastService);

  sendEmail(email: Email, audits?: Nvp[]): Observable<void> {
    return this.http.post<void>('/services/cisco/macs/e-mails', email, this.auditHeaderService.getHttpOptions(audits));
  }

  openEmailPreviewModal(
    enduserUsername: string,
    emailTemplatePreview?: EmailTemplatePreviewFieldConfig,
    cucmServerId?: number,
  ): void {
    this.ziroModalService
      .openDetailedModal(null, {
        bodyClass: EmailPreviewDetailedModalComponent,
        size: 'lg',
        modalViewProperties: {
          title: 'tkey;helpdesk.send_email.modal.title',
          submitButtonLabel: 'tkey;helpdesk.send_email.modal.submit.label',
          submitButtonIcon: ZiroIcons.SEND_EMAIL,
          enduserUsername: enduserUsername,
          emailTemplatePreview: emailTemplatePreview,
          cucmServerId: cucmServerId,
        },
      })
      .subscribe(() => {
        this.toastService.push(
          ToastTypes.SUCCESS,
          ZiroIcons.SEND_EMAIL,
          'tkey;helpdesk.send_email.toast.title',
          'tkey;helpdesk.send_email.toast.message',
        );
      });
  }
}
